import axios from 'axios';
import { withRetry } from './apiRetry';
import { sessionRedirect } from './sessionRedirect';
import { tryRefresh } from './refreshToken';

const BACKEND_URL = '';

export const getClientToken = () => localStorage.getItem('client_token');
export const setClientToken = (token) => localStorage.setItem('client_token', token);
export const removeClientToken = () => {
  localStorage.removeItem('client_token');
  localStorage.removeItem('client_user');
  localStorage.removeItem('client_refresh_token');
};
export const getClientUser = () => { const u = localStorage.getItem('client_user'); return u ? JSON.parse(u) : null; };
export const setClientUser = (user) => localStorage.setItem('client_user', JSON.stringify(user));
export const isClientAuthenticated = () => !!getClientToken();

// Axios instance for client API calls
export const clientApi = axios.create({
  baseURL: BACKEND_URL,
  timeout: 30000,
});

clientApi.interceptors.request.use((config) => {
  const token = getClientToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Retry transient failures before giving up
withRetry(clientApi);

// 401 handler — try silent refresh, fall back to session-expiry redirect.
clientApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthCall = /\/auth\/(login|refresh)/i.test(url);
    if (status === 401 && !isAuthCall && !error.config.__hasRetriedAuth) {
      const newToken = await tryRefresh('client');
      if (newToken) {
        error.config.__hasRetriedAuth = true;
        error.config.headers.Authorization = `Bearer ${newToken}`;
        return clientApi.request(error.config);
      }
      sessionRedirect('client');
    }
    return Promise.reject(error);
  }
);